// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1zfXq","title":"Header_title__27z8g","side":"Header_side__2VG6c"};